import moment from 'moment'

const certificate = (state, getters, rootState) => {
  try {
    let cert = null

    if (
      rootState &&
      rootState.attendanceStore &&
      rootState.attendanceStore.certificate &&
      Object.keys(rootState.attendanceStore.certificate).length > 0
    ) {
      cert = rootState.attendanceStore.certificate
    }

    if (!cert || typeof cert !== 'object' || Object.keys(cert).length === 0) {
      const stored = localStorage.getItem('singItemAutentic')
      if (stored) {
        try {
          cert = JSON.parse(stored)
        } catch (parseError) {
          console.error(
            '[store/getters.certificate] Erro ao fazer parse do singItemAutentic:',
            parseError
          )
          cert = null
        }
      }
    }

    if (!cert) {
      return { active: 'inative' }
    }

    const base = { ...cert }

    if (base.cert && base.cert.validityEnd) {
      try {
        const formattedValidity = moment(base.cert.validityEnd).format(
          'DD/MM/YYYY'
        )
        base.cert = {
          ...base.cert,
          validityEnd: formattedValidity
        }
      } catch (formatError) {
        console.error(
          '[store/getters.certificate] Erro ao formatar validityEnd:',
          formatError
        )
      }
    }

    if (typeof base.active === 'undefined') {
      base.active = 'inative'
    }

    return base
  } catch (error) {
    console.error('[store/getters.certificate] Erro ao obter certificado:', error)

    try {
      const stored = localStorage.getItem('singItemAutentic')
      if (stored) {
        const auxCert = JSON.parse(stored)
        if (auxCert && auxCert.cert && auxCert.cert.validityEnd) {
          auxCert.cert.validityEnd = moment(auxCert.cert.validityEnd).format(
            'DD/MM/YYYY'
          )
        }
        return auxCert
      }
    } catch (fallbackError) {
      console.error(
        '[store/getters.certificate] Erro no fallback legado:',
        fallbackError
      )
    }

    return { active: 'inative' }
  }
}

const showTitle = state => title => {
  const formNames = state.attendance.menu.groups[title]
  return formNames.some(formName => state.attendance.form[formName].showing)
}

export default {
  certificate,
  showTitle
}
